(function () {
'use strict';

function generalInit() {
	(function ($) {

		window.headerHeight = 76;
		window.scrollOffset = window.headerHeight;

		function myScrollTo($target, $trigger) {
			if ($target.length) {
				var offTop = $target.offset().top;

				if ($trigger.attr('data-ignore-header') === undefined) {

					offTop -= window.scrollOffset;

					if ($('[data-fixed-nav-menu]:visible').length) offTop -= $('[data-fixed-nav-menu]').outerHeight();

					// offTop -= $('#site-header').outerHeight();
					// offTop -= 40;
				}

				offTop = Math.ceil(offTop);

				var animationTime = 700;

				if ($trigger.attr('data-speed')) {
					animationTime = parseInt($trigger.attr('data-speed'));
				}
				if (!animationTime) {
					animationTime = Math.abs(offTop - $(window).scrollTop()) * 0.6;
				}

				$(window).trigger('smooth-scroll-started');

				$('html, body').stop().animate({ scrollTop: offTop }, animationTime, 'easeOutQuart', function () {
					$(window).trigger('smooth-scroll-ended');
				});
			}
		}

		$('a[href="#"]').click(function (e) {
			e.preventDefault();
		});

		$('a[data-smooth-scroll]').click(function (e) {

			var $target = $($(this).attr('href'));
			if (!$target.length) $target = $(this).closest('section').next('section');

			if ($target.length) e.preventDefault();

			myScrollTo($target, $(this));

		});

		$('a[href^="#"]:not([href="#"]):not([data-tabs-link])').click(function (e) {

			var $target = $($(this).attr('href'));
			if (!$target.length) return;

			e.preventDefault();
			myScrollTo($target, $(this));

		});

		//add simple support for background images:
		$(document).on('lazybeforeunveil', function (e) {
			var bg = $(e.target).attr('data-bg');
			if (bg) {
				e.target.style.backgroundImage = 'url(\'' + bg + '\')';
			}
		});

	})(jQuery);
}

function slidersInit() {

	(function ($) {

		$('#cs-photos__slider').slick({
			dots: false,
			infinite: true,
			slidesToShow: 1,
			autoplay: true,
			speed: 1200,
		});

		$('#cs-description__tabs, .cs-heading__media-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {

			if (currentSlide == nextSlide) return;

			var current = $(slick.$slides.get(currentSlide));
			var next;
			if ((nextSlide < currentSlide && (currentSlide === 1 && nextSlide !== 0)) || (currentSlide === 0 && nextSlide === slick.slideCount - 1)) {
				next = current.prev();
			}
			else {
				next = current.next();
			}

			if (next.hasClass('slick-cloned')) {
				next.addClass('slick-clone-current');
			}
		});

		$('#cs-description__tabs').on('afterChange', function () {
			$('#cs-description__tabs .slick-clone-current').removeClass('slick-clone-current');
		});


		$('#cs-description__tabs').slick({
			// initialSlide: 1,
			autoplay: false,
			infinite: true,
			focusOnSelect: true,
			speed: 800,
			waitForAnimate: false
		});

		$('.cs-heading__media-slider').slick({
			dots: true,
			arrows: true
		});

		$('#cs-description__tabs').on('click', '[data-next-slide]', function (e) {
			$('#cs-description__tabs').slick('slickNext');
		});

	})(jQuery);

}

function menuInit() {

	(function ($) {

		var menu_breakpoint = 'large';

		function fixedNav() {

			if (!$('body').hasClass('fixed-nav')) return;

			var scrolltop = $(window).scrollTop();
			var hTop = 0;
			var hTopLarge = $(window).height() * 0.9 - 76;


			if (scrolltop > hTop && !$('body').hasClass('scrolled')) {
				$('body').addClass('scrolled');
			}
			if (scrolltop <= hTop && $('body').hasClass('scrolled')) {
				$('body').removeClass('scrolled');
			}



			if (scrolltop > hTopLarge && !$('body').hasClass('scrolled-large')) {
				$('body').addClass('scrolled-large');
			}
			if (scrolltop <= hTopLarge && $('body').hasClass('scrolled-large')) {
				$('body').removeClass('scrolled-large');
			}

		}

		function menuEvents() {

			$('#site-header .menu li.menu-item-has-children').append('<div class="arrow">');

			$('#site-header .menu li.menu-item-has-children .arrow').click(function () {
				$(this).siblings('.sub-menu').stop().slideToggle(200);
			});

			$('#site-header .menu li.menu-item-has-children > a[href="#"]').click(function () {
				if (!Foundation.MediaQuery.atLeast(menu_breakpoint)) {
					$(this).siblings('.sub-menu').stop().slideToggle(200);
				}
			});

			// $('#site-header .menu .menu a:not([href="#"])').click(function(){
			// 	if( ! Foundation.MediaQuery.atLeast(menu_breakpoint) ){
			// 		$('#site-header .menu-wrap').removeClass('active');
			// 	}
			// });

			$('[data-show-nav]').click(function () {
				$('#main-nav').addClass('active').stop().fadeIn();
				$('body').addClass('nav-visible');
			});
			$('[data-close-nav]').click(function () {
				$('#main-nav').removeClass('active').stop().fadeOut(400, () => { $('body').removeClass('nav-visible'); });

			});

			$('#site-header .menu li.menu-item-has-children').hover(function () {
				if (Foundation.MediaQuery.atLeast(menu_breakpoint)) {
					$(this).children('.sub-menu').stop().fadeIn(200);
				}
			}, function () {
				if (Foundation.MediaQuery.atLeast(menu_breakpoint)) {
					$(this).children('.sub-menu').stop().fadeOut(200);
				}
			});

			$(window).on('changed.zf.mediaquery', function () {
				if (Foundation.MediaQuery.atLeast('large')) {
					$('#site-header .menu .sub-menu').hide();
				}
			});

		}

		fixedNav();
		menuEvents();

		$(window).scroll(function () {
			requestAnimationFrame(function () {
				fixedNav();
			});
		});

	})(jQuery);

}

function galleryInit() {
	(function ($) {

		$('.post-content .gallery').each(function (i) {
			$(this).find('.gallery-item').each(function () {

				$(this).find('.gallery-icon a').attr('data-fancybox', 'post-gallery-' + i);

				if ($(this).find('.wp-caption-text')) {
					var captionText = $(this).find('.wp-caption-text').html();
					$(this).find('.gallery-icon a').attr('data-caption', captionText);
				}
			});
		});

	})(jQuery);
}

function loadMoreInit() {
	(function ($) {

		function ajax_show_more($wrapper, template, btn) {

			if (btn.hasClass('is-loading')) return;


			var data = {
				'action': 'hp_loadmore',
				'query': wp_params.posts, // that's how we get wp_params from wp_localize_script() function
				'page': wp_params.current_page,
				'template': template
			};

			$.ajax({
				url: wp_params.ajax_url, // AJAX handler
				data: data,
				type: 'POST',
				beforeSend: function () {
					btn.addClass('is-loading');
				},
				success: function (data) {
					if (data) {

						var disp = $wrapper.children().first().css('display');

						$wrapper.append(data);
						$wrapper.find('.ajax-loaded').css({ display: disp }).hide();
						$wrapper.find('.ajax-loaded').fadeIn(400).removeClass('ajax-loaded');

						btn.removeClass('is-loading');

						wp_params.current_page++;

						if (wp_params.current_page == wp_params.max_page) {
							btn.addClass('fading').fadeOut(400);
							btn.removeClass('is-loading').addClass('no-posts');
						}
						// you can also fire the "post-load" event here if you use a plugin that requires it
						$(document.body).trigger('post-load');
						$(window).trigger('resize');

					} else {
						btn.addClass('fading').fadeOut(400);
						btn.removeClass('is-loading').addClass('no-posts');
					}
				}
			});
		}


		// Preload icon
		$('[data-loadmore]').addClass('is-loading');
		setTimeout(function () {
			$('[data-loadmore]').removeClass('is-loading');
		}, 20);

		$('[data-loadmore]').on('click', function () {
			var $wrapper = $($(this).attr('data-wrap'));
			var btn = $(this);
			var template = $(this).attr('data-template');

			ajax_show_more($wrapper, template, btn);
		});

	})(jQuery);
}

var ScrollBoxInit;

(function ($) {

	const selectors = {
		box: '[data-scroll-box]'
	};

	var winData = {
		height: $(window).height()
	};

	ScrollBoxInit = class ScrollBoxInit {
		constructor() {
			this.init();
		}
		init() {
			$(selectors.box).each((i, el) => {
				new ScrollBox(el);
			});
		}
	};

	class ScrollBox {
		constructor(element) {
			this.box = element;

			this.init();
			this.resize();
			this.bind();

			// console.log(this);

		}
		init() {

			var w = $(this.box).attr('data-width') ? $(this.box).attr('data-width') : $(this.box).outerWidth();

			if (w.indexOf('vw') != -1) {
				w = w.replace('vw', '');
				w = (parseFloat(w) / 100) * $(window).width();
			}

			w = parseFloat(w);

			this.width = w;
			this.offset = this.width - $(this.box).parent().width();

		}
		bind() {

			// const throttledScroll = throttle(30, false, () => {
			// 	this.scroll();
			// });

			$(document).ready((e) => { this.resize(); });
			$(window).resize((e) => { this.resize(); });
			// $(window).scroll( (e) => { throttledScroll(); } );
			$(window).scroll((e) => { this.scroll(); });

		}
		resize() {
			$(this.box).width(this.width);

			this.offTop = $(this.box).offset().top;
			this.height = $(this.box).outerHeight();
			winData.height = $(window).height();

			this.scroll();
		}

		scroll() {

			// var time = window.performance.now();
			// console.log(time);

			// var perc = ( $(window).scrollTop() + winData.height*0.75 - this.offTop ) / ( this.height );
			// var perc = ( $(window).scrollTop() + winData.height/2 - this.offTop ) / ( this.height );
			var perc = ($(window).scrollTop() + winData.height * 0.9 - this.offTop) / (this.height);
			var new_off = -(perc * this.offset);

			$(this.box).css('transform', 'translateX(' + new_off + 'px)');

			// console.log(window.performance.now() - time);

		}

	}

})(jQuery);


var ScrollBoxInit$1 = ScrollBoxInit;

var ScrollNavInit;

(function ($) {

	const selectors = {
		navContainer: '[data-scroll-nav]',
		fixtoWrapper: '[data-fixto-wrapper]'
	};

	ScrollNavInit = class ScrollNavInit {
		constructor() {
			this.init();
		}
		init() {
			$(selectors.navContainer).each((i, el) => {
				new ScrollNav(el);
			});
		}
	};

	class ScrollNav {
		constructor(element) {
			this.nav = element;

			this.init();
			this.resize();
			this.bind();
			this.checkBreakpoint();


		}
		init() {

			this.links = $('a[href^="#"]:not([href="#"])', this.nav);

			if ($(this.nav).closest(selectors.fixtoWrapper).length) {
				this.fixto = fixto.fixTo(this.nav, $(this.nav).closest(selectors.fixtoWrapper).get(0), {
					top: window.scrollOffset ? window.scrollOffset : 0,
					useNativeSticky: false
				});
			}

			this.targets = [];
			this.links.each((i, link) => {

				var $target = $($(link).attr('href'));

				if ($target.length) {
					this.targets.push({
						el: $target.get(0),
						link: link,
						offset: $target.offset().top
					});
				}

			});
		}
		resize() {
			$(this.targets).each((i, targetData) => {
				targetData.offset = $(targetData.el).offset().top;
			});

			this.targets.sort((a, b) => (a.offset > b.offset) ? 1 : ((b.offset > a.offset) ? -1 : 0));

		}
		bind() {

			$(document).ready((e) => { this.resize(); });
			$(window).resize((e) => { this.resize(); });

			$(window).scroll((e) => { this.scroll(); });

			$(window).on('smooth-scroll-started', (e) => { this.isScrolling = true; });
			$(window).on('smooth-scroll-ended', (e) => { this.isScrolling = false; });

			$(window).on('changed.zf.mediaquery', (e) => { this.checkBreakpoint(); });

			$(this.links).click((e) => { this.linkClicked($(e.target).closest('a').get(0)); });
		}

		scroll() {

			if (this.isScrolling) return;

			var _this = this;

			// console.log("#######");

			$(this.targets).each((i, targetData) => {

				var scrollOff = $(window).scrollTop();
				if (window.scrollOffset) scrollOff += window.scrollOffset;

				var is_active = scrollOff >= targetData.offset;

				if (i < _this.targets.length - 1 && scrollOff >= _this.targets[i + 1].offset)
					is_active = false;

				if (is_active) {
					$(targetData.link).addClass('is-active');
				}
				else {
					$(targetData.link).removeClass('is-active');
				}

			});

		}

		checkBreakpoint() {

			if (Foundation.MediaQuery.atLeast('medium')) {
				this.fixto.start();
			}
			else {
				this.fixto.stop();
			}
		}

		linkClicked(link) {
			$(this.links).removeClass('is-active');
			$(link).addClass('is-active');
		}

	}

})(jQuery);


var ScrollNavInit$1 = ScrollNavInit;

var FixedNavInit;

(function ($) {

	const selectors = {
		navContainer: '[data-fixed-nav]',
		navMenu: '[data-fixed-nav-menu]',
	};

	FixedNavInit = function () {
		$(selectors.navContainer).each((i, el) => {
			new FixedNav(el);
		});
	};

	class FixedNav {
		constructor(element) {
			this.$wrap = $(element);
			this.$nav = $(selectors.navMenu, this.$wrap);

			this.init();
			this.resize();
			this.bind();

		}
		init() {

			this.links = $('a[href^="#"]:not([href="#"])', this.$nav);
			this.targets = [];
			this.menuOffsetTop = this.$wrap.offset().top;
			this.is_sticky = false;
			this.links.each((i, link) => {
				var $target = $($(link).attr('href'));
				if ($target.length) {
					var targetData = {
						el: $target.get(0),
						link: link,
						offset: $target.offset().top - 5
					};

					if ($(targetData.link).attr('data-offset') !== undefined) {
						targetData.offset -= parseFloat($(targetData.link).attr('data-offset'));
					}
					else if (window.headerHeight && $(targetData.link).attr('data-ignore-header') === undefined) {
						targetData.offset -= window.headerHeight;
					}

					this.targets.push(targetData);
				}
			});

		}
		resize() {

			this.menuOffsetTop = this.$wrap.offset().top;

			$(this.targets).each((i, targetData) => {

				targetData.offset = $(targetData.el).offset().top - 5;

				if ($(targetData.link).attr('data-offset') !== undefined) {
					targetData.offset -= parseFloat($(targetData.link).attr('data-offset'));
				}
				else if (window.headerHeight && $(targetData.link).attr('data-ignore-header') === undefined) {
					targetData.offset -= window.headerHeight;
				}
			});

			this.targets.sort((a, b) => (a.offset > b.offset) ? 1 : ((b.offset > a.offset) ? -1 : 0));

			this.scroll();

		}
		bind() {

			$(document).ready((e) => { this.resize(); });
			$(window).resize((e) => { this.resize(); });

			$(window).scroll((e) => { this.scroll(); });

			$(window).on('smooth-scroll-started', (e) => { this.isScrolling = true; });
			$(window).on('smooth-scroll-ended', (e) => { this.isScrolling = false; });
			$(window).on('smooth-scroll-ended', (e) => { this.scroll(); });

			$(this.links).click((e) => { this.linkClicked($(e.target).closest('a').get(0)); });
		}

		scroll() {

			const scrollOff = $(window).scrollTop() + $('#site-header').outerHeight();

			if (scrollOff >= this.menuOffsetTop && !this.is_sticky) {
				this.stick();
			}
			else if (scrollOff < this.menuOffsetTop && this.is_sticky) {
				this.unstick();
			}

			this.setActive();

		}


		linkClicked(link) {

			if (!$($(link).attr('href')).length) return;

			$(this.links).removeClass('is-active');
			$(link).addClass('is-active');
		}

		stick() {
			this.is_sticky = true;
			this.$wrap.css('height', this.$wrap.outerHeight());
			this.$nav.addClass('is-sticky');
			$(document.body).addClass('has-sticky-nav');
		}

		unstick() {
			this.is_sticky = false;
			this.$wrap.css('height', '');
			this.$nav.removeClass('is-sticky');
			$(document.body).removeClass('has-sticky-nav');
		}

		setActive() {

			if (this.isScrolling) return;

			const self = this;
			const scrollOff = $(window).scrollTop() + $('#site-header').outerHeight();
			var has_active = false;

			$(this.targets).each((i, targetData) => {

				var is_active = scrollOff >= targetData.offset;

				if (i < self.targets.length - 1 && scrollOff >= self.targets[i + 1].offset) {
					// console.log('next active');
					is_active = false;
				}

				if (is_active) {
					$(targetData.link).addClass('is-active');
					has_active = true;
				}
				else {
					$(targetData.link).removeClass('is-active');
				}

			});

			if (!has_active && this.targets.length) {
				$(this.targets[0].link).addClass('is-active');
			}

		}

	}

})(jQuery);


var FixedNavInit$1 = FixedNavInit;

var ParallaxInit;

(function ($) {

	const selectors = {
		box: '[data-parallax]'
	};

	var winData = {
		height: $(window).height()
	};

	ParallaxInit = class ParallaxInit {
		constructor() {
			this.init();
		}
		init() {
			$(selectors.box).each((i, el) => {
				new Parallax(el);
			});
		}
	};

	class Parallax {
		constructor(element) {
			this.box = element;

			this.init();
			this.resize();
			this.bind();

			// console.log(this);

		}
		init() {
			this.speed = $(this.box).attr('data-speed') ? parseFloat($(this.box).attr('data-speed')) : 1.2;
			this.wrap = $(this.box).parent().get(0);

			this.direction = $(this.box).attr('data-direction') ? $(this.box).attr('data-direction').toLowerCase() : 'y';
			this.additionalScrollOffset = $(this.box).attr('data-scroll-offset') ? parseInt($(this.box).attr('data-scroll-offset')) : 0;
			this.from = $(this.box).attr('data-from') ? $(this.box).attr('data-from') : 'center';
			this.breakpoint = $(this.box).attr('data-from-breakpoint') ? $(this.box).attr('data-from-breakpoint') : false;

			$(this.wrap).addClass('parallax-wrap');


		}
		bind() {

			// const throttledScroll = throttle(30, false, () => {
			// 	this.scroll();
			// });

			$(document).ready((e) => { this.resize(); });
			$(window).resize((e) => { this.resize(); });
			// $(window).scroll( (e) => { throttledScroll(); } );
			$(window).scroll((e) => { this.scroll(); });

		}
		resize() {
			// $(this.box).width( this.width );
			// 
			this.wrapOffTop = $(this.wrap).offset().top;
			this.wrapHeight = $(this.wrap).outerHeight();
			winData.height = $(window).height();

			this.scroll();
		}

		scroll() {

			if (this.breakpoint && !Foundation.MediaQuery.atLeast(this.breakpoint)) {
				$(this.box).css('transform', '');
				return;
			}

			var scroll_off;

			if (this.from == "center") {
				scroll_off = $(window).scrollTop() - this.additionalScrollOffset - this.wrapOffTop + winData.height / 2 - this.wrapHeight / 2;
			}
			else if (this.from == "top") {
				scroll_off = $(window).scrollTop() - this.additionalScrollOffset - this.wrapOffTop;
			}

			var new_off = scroll_off * (1 - this.speed);


			// console.log(scroll_off);

			if (this.direction == 'y') {
				$(this.box).css('transform', 'translateY(' + new_off + 'px)');
			}
			else if (this.direction == 'x') {
				$(this.box).css('transform', 'translateX(' + new_off + 'px)');
			}


		}

	}

})(jQuery);


var ParallaxInit$1 = ParallaxInit;

var StickyInit;

(function ($) {

	const selectors = {
		box: '[data-sticky]',
		content: '[data-sticky-content]'
	};


	StickyInit = class StickyInit {
		constructor() {
			this.init();
		}
		init() {
			$(selectors.box).each((i, el) => {
				new Sticky(el);
			});
		}
	};

	class Sticky {
		constructor(element) {
			this.box = element;

			this.init();
			this.resize();
			this.bind();

			// console.log(this);

		}
		init() {

			this.content = $(selectors.content, this.box).get(0);
			$(this.content).css({ 'position': 'absolute', 'top': 0 });
			$(this.box).css({ 'position': 'relative' });
			// this.amount = $(this.box).attr('data-amount') ? parseInt( $(this.box).attr('data-amount') ) : 0;
			// this.rate = 0.5;

		}
		bind() {
			$(window).scroll((e) => { this.scroll(); });
			$(window).resize((e) => { this.resize(); });
		}

		resize() {

			this.headerHeight = $('#site-header').outerHeight() + $('[data-fixed-nav]').outerHeight();
			this.bodyHeight = $(window).height() - this.headerHeight;

			this.contentHeight = $(this.content).outerHeight(true);

			this.startScroll = $(this.box).offset().top - this.headerHeight;
			this.endScroll = $(this.box).offset().top + $(this.box).outerHeight() - $(window).height();


			// if( this.contentHeight < this.bodyHeight ){
			this.startScroll -= (this.bodyHeight - this.contentHeight) / 2;
			// }
			this.endScroll += (this.bodyHeight - this.contentHeight) / 2;


			var temp_css = $(this.content).css('position');
			$(this.content).css('position', 'static');
			this.contentTop = $(this.content).position().top;
			$(this.content).css('position', temp_css);


			// $(this.box).css('padding-bottom', this.amount*this.rate);
			$(this.box).css('min-height', this.contentHeight);

			// console.log(this.contentTop);


			// console.log(this);
		}

		scroll() {


			var scroll = $(window).scrollTop();
			scroll = Math.max(this.startScroll, Math.min(scroll, this.endScroll));
			scroll -= this.startScroll;

			// console.log(this.startScroll, $(window).scrollTop(), this.endScroll, scroll);

			// var new_scroll = Math.floor( scroll * this.rate );
			// console.log(scroll, new_scroll);

			$(this.content).css({ 'top': scroll });





			// if( scroll >= this.amount ){
			// 	$(this.content).css({'position': 'absolute', 'top': this.contentTop + scroll });
			// }
			// else
			//  if( scroll > 0 ){
			// 	$(this.content).css({'position': 'fixed', 'top': this.contentTop - scroll});
			// }
			// else {
			// 	$(this.content).css({'position': 'static'});
			// 	
			// }
			// $(this.content).css('transform', 'translateY('+new_scroll+'px) translateZ(0)');
			// $(this.content).css('padding-top', new_scroll);

		}


	}

})(jQuery);


var StickyInit$1 = StickyInit;

var FixtoInit;

(function ($) {

	const selectors = {
		box: '[data-fixto]',
		content: '[data-fixto-content]'
	};


	FixtoInit = class FixtoInit {
		constructor() {
			this.init();
		}
		init() {
			$(selectors.box).each((i, el) => {
				new Fixto(el);
			});
		}
	};

	class Fixto {
		constructor(element) {
			this.box = element;
			this.content = $(selectors.content, this.box).get(0);

			if ($(this.content).length) {
				this.init();
			}

			// console.log(this);

		}
		init() {

			const self = this;

			self.offTop = window.scrollOffset ? window.scrollOffset : 0;
			if ($(this.box).attr('data-offset')) this.offTop += parseInt($(this.box).attr('data-offset'));


			self.fixto = fixto.fixTo(this.content, this.box, {
				top: self.offTop,
				useNativeSticky: false
			});
		}
	}

})(jQuery);


var FixtoInit$1 = FixtoInit;

var DropdownInit;

(function ($) {

	const selectors = {
		box: '[data-dropdown]',
		content: '[data-dropdown-content]'
	};


	DropdownInit = class DropdownInit {
		constructor() {
			this.init();
		}
		init() {
			$(selectors.box).each((i, el) => {
				new Dropdown(el);
			});
		}
	};

	class Dropdown {
		constructor(element) {
			this.$box = $(element);

			if (this.$box.length) {
				this.init();
				this.bind();
			}

		}
		init() {
			this.$content = $(selectors.content, this.$box);
			this.isOpen = this.$box.hasClass('is-open');
		}
		bind() {

			this.onClick = this.onClick.bind(this);

			this.$box.on('click', this.onClick);
		}

		onClick() {

			if (this.isOpen) {
				this.close();
			}
			else {
				this.open();
			}

		}

		open() {
			this.isOpen = true;
			this.$box.addClass('is-open');
			this.$content.stop().slideDown();
		}
		close() {
			this.isOpen = false;
			this.$box.removeClass('is-open');
			this.$content.stop().slideUp();
		}

	}

})(jQuery);


var DropdownInit$1 = DropdownInit;

var TabsInit;

(function ($) {

	const selectors = {
		wrapper: '[data-tabs]',
		links: '[data-tabs-link]',
		tabs: '[data-tabs-tab]',
	};

	TabsInit = function () {
		$(selectors.wrapper).each((i, el) => {
			new Tabs(el);
		});
	};

	class Tabs {

		constructor(wrapper) {

			this.$wrapper = $(wrapper);

			if (this.$wrapper.length) {
				this.init();
			}

		}

		init() {

			this.$tabLinks = $(selectors.links, this.$wrapper);
			this.$tabs = $(selectors.tabs, this.$wrapper);

			this.animate = true;
			this.duration = 700;

			this.bind();

		}
		bind() {
			const self = this;

			self.onTabLinkClicked = self.onTabLinkClicked.bind(self);
			self.$tabLinks.click(self.onTabLinkClicked);

			$(document).on('hp-plugins-loaded', () => {
				self.switchTab('#' + self.$tabs.eq(0).attr('id'), false);
			});

		}

		onTabLinkClicked(e) {
			e.preventDefault();

			const self = this;
			const $link = $(e.target).is('a') ? $(e.target) : $(e.target).closest('a');
			self.switchTab($link.attr('href'));
		}

		switchTab(targetId, animate) {
			if (!targetId) return;

			const self = this;
			const $targetTab = self.$tabs.filter(targetId).eq(0);
			if (animate === undefined) animate = self.animate;

			if ($targetTab.hasClass('is-active')) return;

			$(document).trigger('switching-to-tab', { targetId: targetId, $targetTab: $targetTab });

			self.$tabLinks.removeClass('is-active').filter((i, el) => { return $(el).attr('href') === targetId }).addClass('is-active');

			self.$tabs.removeClass('is-active');
			$targetTab.addClass('is-active');

			if (animate) {

				const $curTab = self.$tabs.filter(':visible');
				const curHeight = $curTab.eq(0).outerHeight();

				$curTab.css('position', 'absolute');
				$targetTab.css('opacity', 0).show();

				const newHeight = $targetTab.outerHeight();

				$curTab.stop().animate({ 'opacity': 0 }, self.duration, function () {
					$(this).hide().css({ 'position': '', opacity: '' });
				});

				$targetTab.css('height', curHeight).stop().animate({ 'height': newHeight, 'opacity': 1 }, self.duration, function () {
					$(this).css({ 'height': '', 'opacity': '' });
				});

			}
			else {
				self.$tabs.hide();
				$targetTab.show();
			}

		}

	}

})(jQuery);


var TabsInit$1 = TabsInit;

var TimelineInit;

(function ($) {

	const selectors = {
		wrapper: '[data-timeline]',
		link: '[data-timeline-link]',
		content: '[data-timeline-content-box]',
	};

	TimelineInit = function () {
		$(selectors.wrapper).each((i, el) => {
			new Timeline(el);
		});
	};

	class Timeline {

		constructor(wrapper) {

			this.$wrapper = $(wrapper);

			if (this.$wrapper.length) {
				this.init();
			}

		}

		init() {

			this.$links = $(selectors.link, this.$wrapper);
			this.$content = $(selectors.content, this.$wrapper);

			this.bind();

			this.showBox(0);

		}
		bind() {
			const self = this;

			self.onLinkClicked = self.onLinkClicked.bind(self);
			self.$links.click(function () { self.onLinkClicked(this); });


		}

		onLinkClicked(link) {

			const self = this;
			const $link = $(link);

			const box_idx = $link.attr('data-idx');

			if (box_idx) {
				self.showBox(box_idx);
			}

		}

		showBox(box_idx) {

			const self = this;
			const $box = self.$content.filter('[data-idx="' + box_idx + '"]');
			const $link = self.$links.filter('[data-idx="' + box_idx + '"]');

			if ($box.hasClass('is-visible')) {
				return;
			}

			self.$content.not($box).removeClass('visible');
			self.$content.not($box).filter(':visible').stop().fadeOut();
			$box.addClass('visible').stop().fadeIn();

			self.$links.not($link).removeClass('is-active');
			$link.addClass('is-active');

		}

	}

})(jQuery);


var TimelineInit$1 = TimelineInit;

var TooltipInit;

(function ($) {

	const selectors = {
		box: '[data-tooltip]',
		content: '[data-tooltip-content]'
	};


	TooltipInit = class TooltipInit {
		constructor() {
			this.init();
		}
		init() {
			$(selectors.box).each((i, el) => {
				new Tooltip(el);
			});
		}
	};

	class Tooltip {
		constructor(element) {
			this.box = element;

			if ($(this.box).length) {
				this.init();
				this.bind();
			}


		}
		init() {
			this.$content = $(selectors.content, this.box);
		}
		bind() {

			this.onMouseEnter = this.onMouseEnter.bind(this);
			this.onMouseOut = this.onMouseOut.bind(this);

			$(this.box).hover(this.onMouseEnter, this.onMouseOut);

		}

		onMouseEnter() {
			this.$content.stop().fadeIn();
		}

		onMouseOut() {
			this.$content.stop().fadeOut();
		}

	}

})(jQuery);


var TooltipInit$1 = TooltipInit;

var matcheHeightInit;

(function ($) {

	const selectors = {
		elem: '[data-mh]',
	};

	matcheHeightInit = function () {
		$(selectors.elem).matchHeight();
	};

})(jQuery);


var matcheHeightInit$1 = matcheHeightInit;

var formInit;

(function ($) {

	const selectors = {
		form: 'form'
	};

	formInit = function () {
		$(selectors.form).each((i, el) => {
			new Form(el);
		});
	};

	class Form {
		constructor(element) {
			this.$form = $(element);

			if (this.$form.length) {
				this.init();
			}

		}

		init() {
			this.bind();
		}

		bind() {

			this.submit = this.submit.bind(this);

			$('[data-submit-on-change]', this.$form).on('change', this.submit);

		}

		submit() {
			this.$form.submit();
		}

	}

})(jQuery);


var formInit$1 = formInit;

var googleMapInit;

(function ($) {

	const selectors = {
		wrapper: '[data-google-map]',
		map: '[data-google-map-map]',
	};


	googleMapInit = function () {
		$(selectors.wrapper).each((i, el) => {
			new GoogleMap(el);
		});
	};

	class GoogleMap {
		constructor(element) {

			this.$wrap = $(element);
			this.$map = $(selectors.map, this.$wrap);

			if (this.$map.length) {
				this.init();
			}

		}
		init() {


			const self = this;

			var latLng = {
				lat: parseFloat(self.$map.attr('data-lat')),
				lng: parseFloat(self.$map.attr('data-lng'))
			};

			// Create gerenic map.
			var mapArgs = {
				zoom: self.$map.data('zoom') || 14,
				center: latLng,
				mapTypeId: self.$map.attr('data-type') || 'roadmap',
				styles: [{ "featureType": "administrative", "elementType": "labels.text.fill", "stylers": [{ "color": "#444444" }] }, { "featureType": "landscape", "elementType": "all", "stylers": [{ "color": "#f2f2f2" }] }, { "featureType": "poi", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "road", "elementType": "all", "stylers": [{ "saturation": -100 }, { "lightness": 45 }] }, { "featureType": "road.highway", "elementType": "all", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "road.arterial", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "water", "elementType": "all", "stylers": [{ "color": "#01bdff" }, { "visibility": "on" }] }]
			};

			self.googleMap = new google.maps.Map(self.$map[0], mapArgs);

			self.marker = new google.maps.Marker({
				position: latLng,
				map: self.googleMap,
				cursor: 'default',
			});

		}
	}

})(jQuery);

var googleMapInit$1 = googleMapInit;

// import PerspectiveBoxInit from './modules/perspective-box';
// import ScrollAnimateInit from './modules/scroll-animate';
(function ($) {

	setTimeout(() => {
		$('body').addClass('is-loaded');
		$(window).trigger('resize').trigger('scroll');

	}, 100);

	$(window).on('load', function () {
		$(window).trigger('resize').trigger('scroll');

		setTimeout(() => {
			$(window).trigger('resize').trigger('scroll');
		}, 500);
	});

	$(document).foundation();

	$(document).ready(function () {

		generalInit();
		slidersInit();
		menuInit();
		galleryInit();
		loadMoreInit();
		TabsInit$1();
		FixedNavInit$1();
		TimelineInit$1();
		matcheHeightInit$1();
		formInit$1();
		googleMapInit$1();

		new ScrollBoxInit$1();
		new ScrollNavInit$1();
		new ParallaxInit$1();
		new DropdownInit$1();
		// new PerspectiveBoxInit();
		new StickyInit$1();
		new FixtoInit$1();
		// new ScrollAnimateInit();
		new TooltipInit$1();

		$(document).trigger('hp-plugins-loaded');

	});

})(jQuery);

}());
